import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Grid,
  Stack,
  Icon,
  Flex
} from '@chakra-ui/react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import EmailForm from './EmailJS/EmailForm';
import MarketingFooter from './MarketingFooter';
import siteConfig from './siteConfig';
import { marketingHeadingStyles } from './marketingStyles';

const ContactPage = () => {
  return (
    <Box fontFamily="var(--telivi-font-body)" sx={marketingHeadingStyles}>
      <Box bgGradient="linear(to-b, gray.50, white)" pt={{ base: 16, lg: 24 }} pb={{ base: 12, lg: 16 }}>
        <Container maxW="container.xl">
          <Stack spacing={4} textAlign="center">
            <Text color="blue.500" fontWeight="600" textTransform="uppercase">
              Contact
            </Text>
            <Heading as="h1" fontSize={{ base: '3xl', md: '5xl' }} fontFamily="var(--telivi-font-heading)">
              Talk with the Telivi platform team
            </Heading>
            <Text color="gray.600" fontSize="lg">
              Ask about platform fit, onboarding, or isolation requirements. We typically respond
              within 1-2 business days.
            </Text>
          </Stack>
        </Container>
      </Box>

      <Box py={{ base: 16, md: 20 }}>
        <Container maxW="container.xl">
          <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={12} alignItems="start">
            <Box>
              <Heading as="h2" fontSize="2xl" mb={6}>
                Contact details
              </Heading>
              <Stack spacing={6}>
                <Flex gap={4} align="center">
                  <Icon as={FaEnvelope} boxSize={6} color="blue.500" />
                  <Box>
                    <Text fontWeight="600">Email</Text>
                    <Text color="gray.600">{siteConfig.supportEmail}</Text>
                  </Box>
                </Flex>
                <Flex gap={4} align="center">
                  <Icon as={FaPhone} boxSize={6} color="blue.500" />
                  <Box>
                    <Text fontWeight="600">Phone</Text>
                    <Text color="gray.600">{siteConfig.contactPhone}</Text>
                  </Box>
                </Flex>
                <Flex gap={4} align="flex-start">
                  <Icon as={FaMapMarkerAlt} boxSize={6} color="blue.500" />
                  <Box>
                    <Text fontWeight="600">Address</Text>
                    <Text color="gray.600">{siteConfig.contactAddress}</Text>
                  </Box>
                </Flex>
              </Stack>
            </Box>
            <EmailForm />
          </Grid>
        </Container>
      </Box>

      <Box h={{ base: '320px', md: '420px' }}>
        <iframe
          src={siteConfig.mapEmbedUrl}
          width="100%"
          height="100%"
          title="Telivi IT Location"
          allowFullScreen
        />
      </Box>

      <MarketingFooter />
    </Box>
  );
};

export default ContactPage;
